<template>
  <div class="base_color">
    <div id="container">
      <div class="crossBox"><van-icon @click="close" class="cross" name="cross" /></div>

      <div class="clause">
        <p style=" font-weight: bold; font-size: 16px;text-align:center">
          担保服务合同
        </p>
        <p class="distance_left">
          本服务合同（以下简称“<span class="distance_bold">本合同</span
          >”）由以下各方签订：
        </p>
        <br />
        <p class="distance_left">
          <span class="distance_bold">甲&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;方</span>：【<span
            class="distance_underline"
            >填入借款人</span
          >】（以下简称“<span class="distance_bold">借款人</span>”）
        </p>
        <p class="distance_left">
          <span class="distance_bold">身份证号</span>：【<span
            class="distance_underline"
            >填入身份证号</span
          >】
        </p>
        <br />

        <p class="distance_left">
          <span class="distance_bold">乙 方</span>：<span class="distance_bold"
            >四川相如鑫源融资担保有限公司</span
          >
        </p>
        <p class="distance_left distance_bold">
          联系人：姜多军
        </p>
        <br />

        <p class="distance_text distance_bold distance_underline">
          特别提示：
        </p>
        <p class="distance_text distance_underline distance_oblique">
          欢迎贵方与乙方共同签订本合同并成为乙方客户！
        </p>
        <p class="distance_text distance_underline distance_oblique">
          本合同各相关条款的标题及其前所列索引关键词仅为帮助贵方理解该等条款之用，不影响或限制本合同条款的含义或解释。为维护贵方自身权益，建议贵方仔细阅读本合同各条款的具体表述。
        </p>
        <p class="distance_text distance_underline distance_oblique">
          贵方在通过平台进行服务申请的流程中以点击确认电子文本方式签订本合同之前，应当认真阅读本合同。请贵方务必审慎阅读、充分理解本合同各条款的内容，特别是有关免除或者限制相关责任、法律适用和争议解决的条款，贵方应重点阅读。
        </p>
        <p class="distance_text distance_underline distance_oblique">
          当贵方在平台按照页面提示填写相关信息并以点击确认电子文本方式签订本合同后，即表示贵方已充分阅读、理解并接受本合同条款的全部内容并受本合同约定内容之约束。阅读本合同的过程中，如果贵方不同意本合同或其中任何条款约定，贵方应立即停止服务申请流程。
        </p>
        <p class="distance_title_bold">
          鉴于：
        </p>
        <p class="distance_50_left">
          A. 甲方通过四川相如鑫源融资担保有限公司的浦望贷业务系统，向上海浦东发展银行股份有限公司（以下简称“债权人”）申请融资等服务，为确保甲方顺利向债权人获取融资服务，甲方委托乙方提供担保服务、还款提示、融资指导等服务；
        </p>
        <p class="distance_50_left">
          B. 甲方自愿与债权人达成“浦望贷”合作意愿，甲方作为借款人充分了解乙方提供担保服务是“<span class="distance_underline">浦望贷</span>”借款合同生效的必要条件，甲方无条件认可乙方收取担保服务费的合法性及合理性；
        </p>
        <p class="distance_50_left">
          C.甲方与债权人签订的《浦银快贷个人借款合同》（以下简称“<span
            class="distance_bold"
            >主合同</span
          >”），约定债权人向甲方授予金融产品、甲方按主合同约定还本付息（以下简称“<span
            class="distance_bold"
            >主债权</span
          >”）；
        </p>
        <p class="distance_50_left">
          D. 乙方就甲方履行能力的稳定性向债权人承担保证责任（以下简称“<span
            class="distance_bold"
            >甲方责任</span
          >”）。
        </p>
        <p class="distance_text">
          有鉴于此，经过平等协商，甲乙双方现达成本合同如下：
        </p>
        <p class="distance_title_bold">
          第一条 服务范围
        </p>
        <p class="distance_50_left distance_text">
          就本合同之目的，乙方为甲方提供如下服务：
        </p>
        <p class="distance_50_left">
          1. 乙方为甲方与债权人签订的“主合同”项下的“主债权”向债权人提供保证；
        </p>
        <p class="distance_50_left">
          2. 其他乙方为本合同之目的向甲方提供的服务。
        </p>
        <p class="distance_title_bold">
          第二条 担保服务费计算标准
        </p>
        <p class="distance_50_left">
          1. 本条所称担保服务费包含乙方及/或其关联方（如有）为甲方提供服务而收取的费用。
        </p>
        <p class="distance_50_left">
          2. 担保服务费率为<span class="distance_underline">3.0%</span>/年，按主债权本金及贷款期限计算，担保服务费总额＝贷款本金×<span class="distance_underline">3.0%</span>×贷款期限（月数，1年计为12月）÷12。
        </p>
        <p class="distance_50_left">
          3. 担保服务费一旦收取，在任何情况下无需退还。
        </p>
        <p class="distance_50_left">
          4. 双方确认，本合同约定的担保服务费价款为含税价。
        </p>
        <p class="distance_title_bold">
          第三条 担保服务费支付
        </p>
        <p class="distance_50_left">
          1. 担保服务费的支付日为主合同下的贷款实际发放日（具体以债权人系统会计记账日期为准）。
        </p>
        <p class="distance_50_left">
          2. 担保服务费由甲方在贷款实际发放日支付至乙方授权上海浦东发展银行代为扣缴上述业务服务费而开设在上海浦东发展银行开立的的指定银行账户。
        </p>
        <p class="distance_50_left">
          3. 如甲方要求乙方出具担保服务费发票的，甲方应在主合同项下贷款实际发放日后五个工作日内至乙方所在地向乙方提交开具担保服务费发票的申请，甲方提交申请时应向乙方提交甲方身份证原件及主合同及本合同电子版打印件供乙方审核，乙方应在审核通过后五个工作日向甲方核准服务费发票。
        </p>
        <p class="distance_50_left">
          4. 甲方核准通过后，乙方应通过甲方的电子发票平台自行打印电子发票。
        </p>
        <p class="distance_title_bold">
          第四条 违约责任
        </p>
        <p class="distance_50_left">
          1. 甲方未按本合同约定向乙方支付担保服务费的，自应向乙方支付担保服务费之日起，按每日万分之五的利率向乙方支付欠付担保服务费的利息，直至甲方付清担保服务费之日，并应同时向乙方支付欠付担保服务费10%的违约金。
        </p>
        <p class="distance_50_left">
          2. 甲方未履行或未完全履行本合同其他义务的，应按主债权金额的20%向乙方支付违约金。
        </p>
        <p class="distance_50_left">
          3. 若因甲方违约给乙方造成损失且违约金不足以赔偿的，甲方应支付相应的赔偿金，包括但不限于律师费、诉讼费、调查取证费、评估费、拍卖费、公证费、保全费、差旅费等。
        </p>
        <p class="distance_title_bold">
          第五条 双方约定的其它条款
        </p>
        <p class="distance_text">
          双方同意，就乙方为甲方提供本合同下服务之目的，乙方有权向甲方采集取得并留存与主合同项下借款有关的甲方、甲方担任法人的企业之相关信息（包括但不限于借款人姓名、身份证号码、手机号码，借款人作为法定代表人的企业信用评分及企业名称、企业统一社会信用代码）。乙方使用上述信息的范围、具体用途、使用方式应同本合同目的相关且不违反法律、行政法规、规章以及行业规范。甲方应保证向乙方提供的各种信息和资料是真实、准确、完整、有效和合法的，如因甲方提供虚假信息和资料导致乙方及债权人无法履行主合同和本合同项下义务，由此产生的法律责任和后果由甲方承担，并且甲方应当承担赔偿乙方损失的责任。
        </p>
        <p class="distance_title_bold">
          第六条 服务先决条件
        </p>
        <p class="distance_50_left distance_text">
          除非本条所规定的服务先决条件已获满足或已被乙方放弃，否则，乙方有权拒绝为甲方提供本合同项下服务：
        </p>
        <p class="distance_50_left">
          1. 甲方已向乙方提交乙方要求的全部文件和资料，且乙方已取得该等文件和资料;
        </p>
        <p class="distance_50_left">
          2. 甲方向债权人提交另债权人满意的资金划扣申请文件，且债权人同意按本合同之约定代为甲方向乙方划扣担保服务费；
        </p>
        <p class="distance_50_left">
          3. 甲方同意并配合乙方采集涉及甲方的信用、经济、司法等信息用于对甲方进行信用评估，且乙方已通过借款人知晓信用评估结果;
        </p>
        <p class="distance_50_left">
          4. 甲方在本合同项下做出的所有陈述和保证均为真实的、且都得到了信守;
        </p>
        <p class="distance_50_left">
          5. 甲方对乙方提供的服务内容全部知悉且同意;
        </p>
        <p class="distance_50_left">
          6. 甲方没有发生并持续存在任何违约事件，或虽发生违约事件但已得到令乙方满意的解决或得到乙方的豁免;
        </p>
        <p class="distance_50_left">
          7. 其他乙方提供服务需要甲方满足的条件。
        </p>
        <p class="distance_title_bold">
          第七条 甲方的义务、陈述及保证
        </p>
        <p class="distance_50_left">
          1. 甲方是具有完全民事权利能力和民事行为能力、能够独立承担民事责任的自然人，具有与其签署债权人主合同相适应的风险识别能力和判断能力，甲方应保证其申请贷款的目的真实、合法，并按照其与债权人的相关约定中所载用途使用贷款资金，且具备足够的融资经历及相适应的融资能力，符合中国法律法规关于其申请贷款的各项要求。
        </p>
        <p class="distance_50_left">
          2. 按乙方要求报送甲方的财务情况文件材料，并保证其真实性、合法性、完整性。在甲方履行完毕本合同项下权利义务之前，乙方有权要求甲方提供信用信息和授信情况。如乙方要求，甲方通过在线点击确认的方式完成本合同的签署应视同已同意并授权乙方查询甲方的信用信息和授信情况。
        </p>
        <p class="distance_50_left">
          3. 甲方应按照申请材料及主合同的约定用途使用款项。
        </p>
        <p class="distance_50_left">
          4. 在主合同项下债务可抵销的情形下，甲方必须毫不迟延地将主债务可抵销的情形通知乙方；必须经乙方同意，甲方方可放弃行使主合同项下债务的抵销权。
        </p>
        <p class="distance_50_left">
          5. 在主合同存在可撤销的情形下，甲方必须毫不迟延地将上述情形通知乙方及弘昊科技；必须经乙方同意，甲方方可放弃行使主合同的撤销权。
        </p>
        <p class="distance_50_left">
          6. 未经乙方同意，甲方不得放弃其到期债权、无偿转让财产或者以明显不合理的低价转让财产。
        </p>
        <p class="distance_50_left">
          7. 主合同有任何修改、补充时，甲方须征得乙方书面同意。
        </p>
        <p class="distance_50_left">
          8. 主合同在履行过程中发生任何重大事项，包括但不限于债权人宣布甲方违约、债权提前到期等，甲方保证在该事项发生当日书面通知乙方，并有义务采取任何措施以避免乙方权益受侵害。
        </p>
        <p class="distance_title_bold">
          第八条 通知送达
        </p>
        <p class="distance_50_left">
          1. 甲乙双方之间的书面通知，可由专人送达、挂号邮递、特快专递、传真、电子邮件等方式传送。甲方同意乙方使用电子方式通知甲方。电子方式包括但不限于以电子邮件方式、网站短消息、或于乙方网站上公布、或无线通讯装置通知等方式。甲方同意，乙方以电子方式发出前述通知之日视为通知已送达。因信息传输等原因导致甲方未在前述通知发出当日收到该等通知的，乙方不承担任何责任。上述约定的送达方式及送达地址的适用范围包括非诉阶段和争议进入仲裁、民事诉讼程序后的一审、二审、再审和执行程序。采用电子通讯方式送达的，送达人员应当保留相应的备份材料及相关的视频截图。
        </p>
        <p class="distance_50_left">
          2. 下列情形视为通知送达：
        </p>
        <p class="distance_50_left">
          （1）专人递送的通知，在专人递送之交付日为有效送达；
        </p>
        <p class="distance_50_left">
          （2）以挂号信（付清邮资）发出的通知，在寄出（以邮戳为凭）后的第4日为有效送达；
        </p>
        <p class="distance_50_left">
          （3）以特快专递（付清邮资）发出的通知，在寄出（以邮戳为凭）后的第3日为有效送达；
        </p>
        <p class="distance_50_left">
          （4）以传真发出的通知，在传真发出时视为送达；
        </p>
        <p class="distance_50_left">
          （5）以电子邮件发出的通知，在发送人的邮件系统确认电子邮件发送至收件人的邮件接收系统时视为送达，电子邮件送达与书面送达具有同等法律效力。
        </p>
        <p class="distance_50_left">
          3. 双方在本合同中填写的住所地即为其有效的通讯地址。
        </p>
        <p class="distance_50_left">
          4. 甲方保证，如住所、通讯地址等发生变更时，及时将变更通知书面送达至乙方。否则，乙方按照本合同指定联系地址对其送达有关文件时，不论甲方是否收悉，均视为乙方已履行了通知义务及送达义务。在此情况下，甲方自愿放弃对乙方所负通知义务的抗辩权。
        </p>
        <p class="distance_title_bold">
          第九条 管辖
        </p>
        <p class="distance_text">
          因签订或履行本合同引起或与之有关的任何争议，存有争议的各方应通过友好协商予以解决。如果在本合同一方向另一方发出书面通知要求就争议开始进行协商后三十日内争议未能得到解决，则任何一方均可将争议提交上海国际经济贸易仲裁委员会仲裁裁决，仲裁地为上海，仲裁裁决为终局裁决，对各方均具有约束力。
        </p>
        <p class="distance_title_bold">
          第十条 其他事项
        </p>
        <p class="distance_50_left">
          1. 本合同通过电子数据的方式订立，即由甲方通过在线点击确认的方式完成合同的签署及订立并即时生效，甲方通过债权人系统生成的本合同】由乙方系统保存。甲方如对本合同的真伪或内容有任何疑问或争议，应以乙方业务系统生成的本合同文本为准。
        </p>
        <p class="distance_50_left">
          2. 除本合同另有约定，本合同生效后，任何有关本合同的补充、修改、变更等均须由双方协商一致并订立书面协议。未经另一方书面同意，一方不得单方解除本合同。
        </p>
        <p class="distance_50_left">
          3. 本合同序言和附件是本合同的一部分，与本合同具有同等法律效力。
        </p>
        <p class="distance_title_bold">
          第十一条 告知和说明
        </p>
        <p class="distance_text">
          乙方已采取合理方式提请甲方注意本合同项下所有条款，并按甲方要求对有关条款予以充分说明；甲乙双方对本合同所有条款内容的理解不存在任何疑义和歧义。
        </p>
        <p class="distance_left">
          （以下无正文）
        </p>
        <br />
        <br />
        <p class="distance_left">
          （本页无正文，为《服务合同》签字页）
        </p>
        <br />
        <br />
        <p class="distance_left distance_bold">
          甲方签字：________________________
        </p>
        <br />
        <br />
        <p class="distance_left">
          <span class="distance_bold"> 乙&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;方：四川相如鑫源融资担保有限公司</span
          >（盖章）
        </p>
        <br />
        <br />
        <p class="distance_left distance_bold">
          法定代表人或授权代表签字：_____闵佩东___________
        </p>
        <br />
        <br />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'GuaranteeServiceContract',
  data() {
    return {};
  },
  props: {
    hidePopup: {
      type: Function,
      default: null,
    },
  },
  methods: {
    close() {
      this.hidePopup();
    },
  },
};
</script>
<style scoped>
.base_color{
  width: 100%;
  height: 100%;
}
.crossBox{
  text-align: right;
}
.cross{
  font-size: 20px;
}
#container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.clause{
  flex: 1;
  overflow: auto;
  background: #fff;
  background-size: contain;
}
* {
  /* width: 90%; */
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-size: 12px;
}
body {
  font-family: '微软雅黑';
}
.distance {
  text-align: left;
}
.distance_50 {
  letter-spacing: 0;
  text-align: left;
  text-indent: 24px;
}
.distance_80 {
  text-align: left;

  /* margin-left: 10px; */
}
p {
  margin-bottom: 8px;
}
#close {
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  padding-right: 10px;
  color: white;
  font-size: 20px;
  line-height: 30px;
  text-align: right;
  background: #3d4145;
}
.table {
  margin: 20px 10px;
}

.distance_title_bold {
  font-weight: bold;
  text-align: left;
}
.distance_text {
  text-align: left;
  text-indent: 24px;

}
.distance_left {
  text-align: left;

}
.distance_50_left {
  text-align: left;
}
.distance_bold {
  font-weight: bold;
}
.distance_underline {
  text-decoration: underline;
}
.distance_oblique{
  font-style:oblique
}
</style>
